export default {
    data: localStorage.getItem('data') || false
}